export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN

// Google Picker for media sources (Google Drive): an API key restricted to the Picker API and this
// app's origin, and the Cloud project number of the Drive OAuth client (the Picker's appId, without
// which the files picked are not readable by the server's drive.file token).
export const GOOGLE_PICKER_API_KEY = process.env.REACT_APP_GOOGLE_PICKER_API_KEY || '';
export const GOOGLE_PICKER_APP_ID = process.env.REACT_APP_GOOGLE_PICKER_APP_ID || '';

// `yarn start` opened on localhost: call the API on this origin, through the dev server's proxy
// (src/setupProxy.js), so the session cookies are first-party. Builds always use API_DOMAIN.
const viaDevServerProxy = process.env.NODE_ENV === 'development'
  && typeof window !== 'undefined'
  && window.location.hostname === 'localhost';

export const config = {
  API_URL: "",
  ID_API_URL: viaDevServerProxy ? window.location.origin : "https://"+API_DOMAIN,
  LOCALSTORAGE_CURRENT_CABINET : 'currentCabinet',
  LOCALSTORAGE_AUTH_USER : 'authUser',
  LOCALSTORAGE_LANGUAGE: 'I18N_LANGUAGE',
  LOCALSTORAGE_M9S_CART: 'M9S_CART',
  LOCALSTORAGE_SETTINGS: 'M9S_SETTINGS',
  LOCALSTORAGE_COMPARE_CHANNELS: 'M9S_CMP_C',
  LOCALSTORAGE_PARTNER: 'M9S_PARTNER_CODE',
  LOCALSTORAGE_CANCELLED_DEVICES: 'M9S_CDP',
  LOCALSTORAGE_APPROVED_DEVICE_USERS: 'M9S_APR',
  LOCALSTORAGE_IS_NEED_REFRESH: 'M9S_INR'
};
export let m9sGlobals = {
  CURRENT_CABINET: "",
  W7_WIDGET_URL: "https://wt7.marketcells.io/:widgetData",
  GOOGLE_FEED_URL: "https://"+API_DOMAIN+"/cabinet_:cabinetUuid/sale/v1/integration/:integrationUuid",
  GA_TRACKING_ID: "G-LRJ1GW8Z9L",
  RSS_CHANNEL_URL: "https://"+API_DOMAIN+"/cabinet_:cabinetUuid/export/channel/rss/:channelUuid"
}
